import i18next from 'i18next';

export const WEBSOCKET_CONNECTION_INIT = 'connect to qlik...';
export const WEBSOCKET_CONNECTION_CLOSE = 'app saved.';
export const WEBSOCKET_LOADING_MESSAGE = i18next.t('LoadingMessages.General');
export const WEBSOCKET_DONE_MESSAGE = i18next.t('LoadingMessages.Finished');
export const WEBSOCKET_GENERAL_ERROR = i18next.t('LoadingMessages.GeneralError');
